import axios from 'axios';

const BASE_URL = 'https://crm.semicoloninnovations.in/api'; 

// --- LOGIN ---
export const loginUser = async (username, password) => {
  const res = await axios.post(`${BASE_URL}/login.php`, { username, password });
  return res.data;
};

// --- BILLS ---
export const getBills = async (staffId) => {
  const res = await axios.get(`${BASE_URL}/bills_get.php?staff_id=${staffId}`);
  return res.data;
};

export const addBill = async (billData) => {
  const res = await axios.post(`${BASE_URL}/bills_add.php`, billData);
  return res.data;
};

// --- PETTY CASH ---
export const getPettyCash = async (userId) => {
  const res = await axios.get(`${BASE_URL}/pettycash_get.php?user_id=${userId}`);
  return res.data;
};

export const addPettyCash = async (txnData) => {
  const res = await axios.post(`${BASE_URL}/pettycash_add.php`, txnData);
  return res.data;
};

// --- USERS (optional for admin) ---
export const getUsers = async () => {
  const res = await axios.get(`${BASE_URL}/users_get.php`);
  return res.data;
};

// --- ADMISSIONS ---
export const addStudent = async (studentData) => {
  try {
    const res = await axios.post(`${BASE_URL}/add_student.php`, studentData);
    return res.data;
  } catch (error) {
    console.error('Add Student API Error:', error);
    return { status: 'error', message: error.message };
  }
};

export const addIntern = async (internData) => {
  try {
    const res = await axios.post(`${BASE_URL}/add_intern.php`, internData);
    return res.data;
  } catch (error) {
    console.error('Add Intern API Error:', error);
    return { status: 'error', message: error.message };
  }
};
export const getInterns = async () => {
  const res = await axios.get(`${BASE_URL}/get_interns.php`);
  return res.data;
};
export const updateIntern = async (id, internData) => {
  try {

    const res = await axios.post(
      `${BASE_URL}/update_intern.php`,
      {
        id,
        ...internData
      }
    );

    return res.data;

  } catch (error) {

    console.error('Update Intern API Error:', error);

    return {
      status: 'error',
      message: error.message
    };

  }
};

export const getStudents = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/students_get.php`);
    return res.data;
  } catch (error) {
    console.error('Get Students API Error:', error);
    return [];
  }
};

export const addSalary = async (payload) => {
  const res = await axios.post(`${BASE_URL}/salaries_add.php`, payload);
  return res.data;
};

export const getSalaries = async (staffId) => {
  const res = await axios.get(`${BASE_URL}/salaries_get.php?staff_id=${staffId}`);
  return res.data;
};
// --- PETTY CASH ---
export const getPettyCashDetails = async (staffId) => {
  const res = await axios.get(`${BASE_URL}/pettycash_get.php?user_id=${staffId}`);
  return res.data;
};

// --- BATCHES ---
export const getStaffBatches = async (staffId) => {
  const res = await axios.get(`${BASE_URL}/staff_batches_get.php?staff_id=${staffId}`);
  return res.data;
};

// --- LEAVES ---
export const getStaffLeaves = async (staffId) => {
  const res = await axios.get(`${BASE_URL}/staff_leaves_get.php?staff_id=${staffId}`);
  return res.data;
};

export const updateLeaveStatus = async (id, status) => {
  const res = await axios.post(`${BASE_URL}/staff_leaves_update.php`, { id, status });
  return res.data;
};

// --- ATTENDANCE ---
export const getAttendance = async (staffId) => {
  const res = await axios.get(`${BASE_URL}/attendance_get.php?staff_id=${staffId}`);
  return res.data;
};
// --- STAFF LEAVES (STAFF SIDE) ---
export const applyLeave = async (leaveData) => {
  const res = await axios.post(`${BASE_URL}/staff_leaves_add.php`, leaveData);
  return res.data;
};

export const getStaffLeavesSelf = async (staffId) => {
  const res = await axios.get(`${BASE_URL}/staff_leaves_get.php?staff_id=${staffId}`);
  return res.data;
};

// --- STAFF SALARIES (STAFF SIDE) ---
export const getStaffSalaries = async (staffId) => {
  const res = await axios.get(`${BASE_URL}/staff_salaries_get.php?staff_id=${staffId}`);
  return res.data;
};
// --- CLIENT MANAGEMENT ---
export const getClients = async (adminId) => {
  const res = await axios.get(`${BASE_URL}/clients_get.php?admin_id=${adminId}`);
  return res.data;
};

export const addClient = async (data) => {
  const res = await axios.post(`${BASE_URL}/clients_add.php`, data);
  return res.data;
};
// --- CLIENT DETAILS ---
export const getClientDetails = async (clientId) => {
  const res = await axios.get(`${BASE_URL}/client_details_get.php?client_id=${clientId}`);
  return res.data;
};

export const addClientProject = async (data) => {
  const res = await axios.post(`${BASE_URL}/client_project_add.php`, data);
  return res.data;
};

export const addClientInvoice = async (data) => {
  const res = await axios.post(`${BASE_URL}/client_invoice_add.php`, data);
  return res.data;
};

export const addClientActivity = async (data) => {
  const res = await axios.post(`${BASE_URL}/client_activity_add.php`, data);
  return res.data;
};
// ==========================
// LEADS (Telecalling)
// ==========================


// 🔹 Update a lead’s status, remarks, or follow-up info
export const updateLead = async (leadData) => {
  const res = await axios.post(`${BASE_URL}/lead_update.php`, leadData);
  return res.data;
};

// 🔹 Optionally: Fetch full lead details with notes (for history modal)
export const getLeadDetails = async (leadId) => {
  const res = await axios.get(`${BASE_URL}/lead_details.php?lead_id=${leadId}`);
  return res.data;
};

// 🔹 Optionally: Add a note (separate API if needed)
export const addLeadNote = async (noteData) => {
  const res = await axios.post(`${BASE_URL}/lead_add_note.php`, noteData);
  return res.data;
};
// FOLDERS
export const getFolders = async () => {
  const res = await axios.get(`${BASE_URL}/folders_get.php`);
  return res.data;
};

export const addFolder = async (payload) => {
  // payload: { name, description, created_by }
  const res = await axios.post(`${BASE_URL}/folders_add.php`, payload);
  return res.data;
};

// LEADS (server-side pagination)
export const getLeads = async (staffId, folderId = 0, page = 1, limit = 10) => {
  const res = await axios.get(`${BASE_URL}/leads_get.php`, {
    params: { staff_id: staffId, folder_id: folderId, page, limit }
  });
  return res.data;
};

// upload leads CSV
export const uploadLeadsCsv = async (formData) => {
  // formData must be a FormData with file, folder_id, assign_staff_id, uploaded_by
  const res = await axios.post(`${BASE_URL}/leads_upload.php`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};


// TASKS
export const addTask = async (taskData) => {
  const res = await axios.post(`${BASE_URL}/tasks_add.php`, taskData);
  return res.data;
};

export const getUnassignedTasks = async () => {
  const res = await axios.get(`${BASE_URL}/tasks_get_unassigned.php`);
  return res.data;
};

export const assignTask = async (assignData) => {
  const res = await axios.post(`${BASE_URL}/task_assign.php`, assignData);
  return res.data;
};

export const getAssignedTasks = async (staffId = 0) => {
  const res = await axios.get(`${BASE_URL}/tasks_get_assigned.php`, { params: { assigned_to: staffId } });
  return res.data;
};

export const getTask = async (taskId) => {
  const res = await axios.get(`${BASE_URL}/task_get.php`, { params: { id: taskId } });
  return res.data;
};

export const updateTaskProgress = async (data) => {
  const res = await axios.post(`${BASE_URL}/task_update_progress.php`, data);
  return res.data;
};

export const addTaskComment = async (data) => {
  const res = await axios.post(`${BASE_URL}/task_add_comment.php`, data);
  return res.data;
};

export const confirmTask = async (data) => {
  const res = await axios.post(`${BASE_URL}/task_mark_confirmed.php`, data);
  return res.data;
};
// transactions
export const addTransaction = async (payload) => {
  // payload can be FormData (for file) or JSON
  if (payload instanceof FormData) {
    const res = await axios.post(`${BASE_URL}/transactions_add.php`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } else {
    const res = await axios.post(`${BASE_URL}/transactions_add.php`, payload);
    return res.data;
  }
};

export const getTransactions = async (params = {}) => {
  const res = await axios.get(`${BASE_URL}/transactions_get.php`, { params });
  return res.data;
};

// in src/service/api.js

export const getTransactionsSummary = async (params = {}) => {
  // params: { from: 'YYYY-MM-DD HH:MM:SS', to: 'YYYY-MM-DD HH:MM:SS' }
  const res = await axios.get(`${BASE_URL}/transactions_summary.php`, { params });
  return res.data;
};


export const deleteTransaction = async (id) => {
  const res = await axios.post(`${BASE_URL}/transactions_delete.php`, { id });
  return res.data;
};

// Groups
export const addGroup = async (payload) => {
  const res = await axios.post(`${BASE_URL}/groups_add.php`, payload);
  return res.data;
};
export const getGroups = async () => {
  const res = await axios.get(`${BASE_URL}/groups_get.php`);
  return res.data;
};
export const getGroupMembers = async (group_id) => {
  const res = await axios.get(`${BASE_URL}/groups_get_members.php`, { params: { group_id }});
  return res.data;
};
export const addGroupMember = async (payload) => {
  const res = await axios.post(`${BASE_URL}/groups_add_member.php`, payload);
  return res.data;
};

// Batches
export const addBatch = async (payload) => {
  const res = await axios.post(`${BASE_URL}/batches_add.php`, payload);
  return res.data;
};
export const getBatches = async () => {
  const res = await axios.get(`${BASE_URL}/batches_get.php`);
  return res.data;
};
export const addStudentsToBatch = async (payload) => {
  const res = await axios.post(`${BASE_URL}/batches_add_students.php`, payload);
  return res.data;
};
export const assignStaffToBatch = async (payload) => {
  const res = await axios.post(`${BASE_URL}/batches_assign_staff.php`, payload);
  return res.data;
};
// add multiple students to a group
export const addGroupMembers = async (payload) => {
  // payload = { group_id: 12, student_ids: [1,2,3] }
  const res = await axios.post(`${BASE_URL}/groups_add_members.php`, payload);
  return res.data;
};
export const addStaff = async (payload) => {
  // payload = { staff_code, name, email, phone, role, department, designation, joining_date }
  const res = await axios.post(`${BASE_URL}/staff_create.php`, payload);
  return res.data;
};
export const getStaffList = async () => {
  const res = await axios.get(`${BASE_URL}/staff_list.php`);
  return res.data;
};
export const getAttendanceByDate = async (date) => {
  // date = '2026-01-01'
  const res = await axios.get(
    `${BASE_URL}/attendance_by_date.php?date=${date}`
  );
  return res.data;
};
export const markAttendance = async (payload) => {
  /*
  payload = {
    staff_id: 1,
    attendance_date: '2026-01-01',
    check_in_time: '09:35',
    check_out_time: '18:10',
    status: 'PRESENT',
    remarks: '',
    marked_by: 1
  }
  */
  const res = await axios.post(
    `${BASE_URL}/attendance_mark.php`,
    payload
  );
  return res.data;
};
export const getAttendanceReport = async (staff_id, month) => {
  // month = '2026-01'
  const res = await axios.get(
    `${BASE_URL}/attendance_report.php?staff_id=${staff_id}&month=${month}`
  );
  return res.data;
};
export const bulkMarkAttendance = async (payload) => {
  /*
  payload = {
    attendance_date: '2026-01-01',
    records: [
      { staff_id, check_in_time, check_out_time, status, remarks }
    ],
    marked_by: 1
  }
  */
  const res = await axios.post(
    `${BASE_URL}/attendance_bulk_mark.php`,
    payload
  );
  return res.data;
};
export const getAttendanceExportData = async (staffId, fromDate, toDate) => {
  const res = await axios.get(
    `${BASE_URL}/attendance_export_data.php?staff_id=${staffId}&from_date=${fromDate}&to_date=${toDate}`
  );
  return res.data;
};

export const addCandidate = async (formData) => {
  const res = await axios.post(`${BASE_URL}/candidate_create.php`, formData);
  return res.data;
};

export const getCandidatesByStatus = async (status) => {
  const res = await axios.get(
    `${BASE_URL}/candidates_by_status.php?status=${status}`
  );
  return res.data;
};

export const updateCandidateStatus = async (payload) => {
  const res = await axios.post(
    `${BASE_URL}/candidate_update_status.php`,
    payload
  );
  return res.data;
};
export const getWorkshopRegistrations = async () => {
  const res = await fetch('https://semicoloninnovations.in/register-workshop/get_workshop_registrations.php');
  return await res.json();
};
export const getStaffListLatest = async () => {
  const res = await axios.get(`${BASE_URL}/staff.php`);
  return res.data;
};

export const getAttendanceByDateLatest = async (date, staff_id = "") => {
  const res = await axios.get(`${BASE_URL}/attendance_by_date.php`, {
    params: {
      date,
      staff_id: staff_id || undefined
    }
  });
  return res.data;
};
